import React, { useCallback, useEffect, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import PropTypes from "prop-types";
import "./MultiSelectDropdown.scss";
import Icons from "../../icons";

const MultiSelectDropdown = ({
  placeholder,
  id,
  className,
  showCheckbox,
  dropdownOptions,
  onValSelect,
  onValRemove,
  iconName="",
  readOnly = true,
}) => {
  const [selectedValues, setSelectedValues] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = useCallback(() => {
    setIsOpen(!isOpen);
  },[isOpen]);

  const onSelect = useCallback(
    (selectedList, selectedItem) => {
      setSelectedValues([...selectedList]);
      onValSelect(selectedList, selectedItem);
    },
    [onValSelect]
  );

  const onRemove = useCallback(
    (selectedList, removedItem) => {
      setSelectedValues([...selectedList]);
      onValRemove(selectedList, removedItem);
    },
    [onValRemove]
  );

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  });

  const handleOutsideClick = useCallback(
    (e) => {
      const div = document.querySelector(
        `.custom-multi-select-wrapper.${className}`
      );
      if (div && div.contains(e.target)) {
        div.classList.add("dropdown-open");
        setIsOpen(true);
      } else {
        div.classList.remove("dropdown-open");
        setIsOpen(false);
      }
    },
    [className]
  );

  useEffect(() => {
    /**To disable the search option in dropdown.*/
    if (readOnly) {
      const inputElements = document.querySelectorAll(
        ".custom-multi-select #search_input"
      );

      // Iterate through the input elements and set readOnly to true
      inputElements.forEach((input) => {
        input.readOnly = true;
      });
    }
  }, [readOnly]);

  /** Used CSS to hide the other selected value &
   * this logic to show the count of selected value instead of value
   * */
  useEffect(() => {
    /**If count div exist then remove it. */
    const isDivExist = document.querySelector(`.${className}  #selected-count`);
    if (isDivExist) {
      isDivExist.remove();
    }
    const searchWrapper = document.querySelector(
      `.${className} .search-wrapper`
    );
    if (selectedValues?.length > 1) {
      const node = document.createElement("span");
      node.innerText = `+${selectedValues?.length - 1}`;
      node.setAttribute("id", "selected-count");
      node.setAttribute("class", "chip");
      searchWrapper.insertBefore(
        node,
        document.querySelector(`.${className} #icon_down_dir`)
      );
    }
    const icon = document.querySelector(
      `.custom-multi-select-wrapper.${className} .dropdown-icon`
    );
    if (selectedValues.length) {
      searchWrapper.classList.add("value-selected");
      icon.classList.add("light");
    } else {
      searchWrapper.classList.remove("value-selected");
      icon.classList.remove("light");
    }
  }, [selectedValues.length, selectedValues, className]);


  return (
    <div className={`custom-multi-select-wrapper ${className}`}>
      <span className="dropdown-icon">{Icons[iconName]}</span>
      <Multiselect
        customCloseIcon={<></>}
        className={iconName.length ? `custom-multi-select` : `custom-multi-select noIcon`}
        placeholder={placeholder}
        showCheckbox={showCheckbox}
        customArrow={
          isOpen ? (
            <>{Icons.chevronPurpleUpArrowIcon}</>
          ) : (
            <>{Icons.chevronDownArrowIcon}</>
          )
        }
        showArrow={true}
        options={dropdownOptions} // Options to display in the dropdown
        displayValue="name" // Property name to display in the dropdown options
        hideSelectedList={false}
        onSelect={onSelect}
        onRemove={onRemove}
        hidePlaceholder={true}
        isSearchable={false}
        readonly
      />
    </div>
  );
};

export default MultiSelectDropdown;

MultiSelectDropdown.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  showCheckbox: PropTypes.bool,
  onValueSelect: PropTypes.func,
  onValueRemove: PropTypes.func,
  dropdownOptions: PropTypes.array,
};
